"use client";
import { Provider } from "react-redux";
import { store } from "lib/redux/store"; // Assuming store is in lib/redux/store.ts
import { FC, ReactNode } from "react";

interface ClientProviderProps {
  children: ReactNode;
}

const ClientProvider: FC<ClientProviderProps> = ({ children }) => {
  // console.log(' REDUX PROVIDER RENDER', new Date().toISOString());
  return <Provider store={store}>{children}</Provider>;
};

export default ClientProvider;
